import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProfileInfo, updateProfile } from '../../features/notifications/utils';
import { initialState, NotificationSettings, Preferences } from "./constants";

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    updatePreference: (
      state,
      action: {
        payload: {
          section: keyof Preferences;
          keyPath: string;
          type: keyof NotificationSettings;
          value: boolean;
          nestedKey?: string;
        };
      }
    ) => {
      const { section, keyPath, type, value, nestedKey } = action.payload;

      if (!state.currentPreferences) return;

      if (nestedKey) {
        const targetSetting = state.currentPreferences[section]?.[keyPath]?.[nestedKey];
       
        if (targetSetting) {
          targetSetting[type] = value;
        } else {
          if(!state.currentPreferences[section]){
            state.currentPreferences[section] = {};
          }

          if(!state.currentPreferences[section]?.[keyPath]){
            state.currentPreferences[section][keyPath] = {};
          }

          state.currentPreferences[section][keyPath][nestedKey] = { [type]: value };
        }
      } else {
        
        const targetSetting = state.currentPreferences[section]?.[keyPath];
        if (targetSetting) {
          targetSetting[type] = value;
        } else {
          if(!state.currentPreferences[section]) {
            state.currentPreferences[section] = {};
          }
          state.currentPreferences[section][keyPath] = { [type]: value };
        }
        
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProfileInfo.fulfilled, (state, action) => {
      const { notifications, organizationNotifications, organization, role, cellPhoneNumber, isSmsAllowed } = action.payload;

      state.currentPreferences.personalActivity = notifications || {};
      state.currentPreferences.organizationActivity = organizationNotifications || {};
      state.orgType = organization?.type;
      state.role = role;
      state.phone = cellPhoneNumber;
      state.isSmsAllowed = isSmsAllowed;
    });
  },
});

export const { updatePreference } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
